export default "__VITE_ASSET__CWBgF$pa__"